import { useState } from 'react'
import { ProcessorDetails } from '@/lib/api/processors'
import { ProcessorHeader } from '../components/processor-header'
import { ProcessorDeleteDialog } from '../components/processor-delete-dialog'
import { ProcessorOverviewCard } from '../components/processor-overview-card'
import { ProcessorMetricsCard } from '../components/processor-metrics-card'
import { NMIConfigurationCard } from './components/nmi-configuration-card'
import { NMIDescriptorCard } from './components/nmi-descriptor-card'
import { NMI3DSCard } from './components/nmi-3ds-card'

interface NMIProcessorDetailsPageProps {
    processor: ProcessorDetails
}

export const NMIProcessorDetailsPage = ({ processor }: NMIProcessorDetailsPageProps) => {
    return (
        <>
            <ProcessorHeader
                type="nmi"
                processor={processor}
            />
            <ProcessorOverviewCard processor={processor} />
            <ProcessorMetricsCard processor={processor} />
            <NMIConfigurationCard processor={processor} />
            <NMIDescriptorCard processor={processor} />
            <NMI3DSCard processor={processor} />
        </>
    )
}

